<div class="wrapper-lg">
    <app-breadcrumbs [items]="[
                     { url: '/course-equalizations', text: 'courseEqualization_listTitle' },
                     {
                        url: '/course-equalizations/' + (isNew ? 'add' : model?.Id),
                        text: isNew ? 'courseEqualization_newTitle' : isReady ? canEdit ? 'courseEqualization_editTitle' : 'courseEqualization_viewTitle' : '...'
                     }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>
            {{'courseEqualization_title' | translate}}
            <app-course-equalization-status [value]="model.Status"></app-course-equalization-status>
        </h1>
        <aside *ngIf="canPickStudent && !studentPickerOpened">
            <button type="button" class="btn btn-outline" (click)="toggleStudentPicker()">
                <i class="fi fi-rs-user"></i>
                {{'courseEqualization_btnPickStudent' | translate}}
            </button>
        </aside>
    </header>

    <app-person-picker *ngIf="studentPickerOpened" (pick)="pickStudent($event)"></app-person-picker>

    <app-alert level="danger" *ngIf="isUnavailable && !studentPickerOpened">
        {{'eServiceNotAvailable' | translate}}
    </app-alert>

    <form #form="ngForm" [class.was-validated]="formSubmitted" *ngIf="isReady && !studentPickerOpened">
        <app-alert level="warning" *ngIf="notAvailable">{{'eServicesNotAvailable' | translate}}</app-alert>

        <app-alert level="warning" *ngIf="model.ReturnComment">{{model.ReturnComment}}</app-alert>

        <ng-container *ngIf="resident">
            <ngb-accordion #acc="ngbAccordion" activeIds="studentData">
                <ngb-panel [title]="'courseEqualization_studentData' | translate" id="studentData">
                    <ng-template ngbPanelContent>
                        <div class="row">
                            <div class="data-value col-sm">
                                <label>{{'courseEqualization_lblStudent' | translate}}</label>
                                <div>{{resident.Name}} {{resident.Surname}}</div>
                            </div>

                            <div class="data-value col-sm">
                                <label>{{'courseEqualization_lblEmail' | translate}}</label>
                                <div>{{resident.Email}}</div>
                            </div>

                            <div class="data-value col-sm">
                                <label>{{'courseEqualization_lblStatus' | translate}}</label>
                                <div>
                                    <ng-container *ngIf="resident.Status; else noValue">
                                        {{resident.Status}}
                                    </ng-container>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="data-value col-sm">
                                <label>{{'courseEqualization_lblSpeciality' | translate}}</label>
                                <div>
                                    <ng-container *ngIf="resident.SpecialityName; else noValue">
                                        {{resident.SpecialityName}}
                                    </ng-container>
                                </div>
                            </div>

                            <div class="data-value col-sm">
                                <label>{{'courseEqualization_lblContactPerson' | translate}}</label>
                                <div>
                                    <ng-container *ngIf="resident.ContactPersonName; else noValue">
                                        {{resident.ContactPersonName}}
                                    </ng-container>
                                </div>
                            </div>

                            <div class="data-value col-sm">
                                <label>{{'courseEqualization_lblStudyYear' | translate}}</label>
                                <div>
                                    <ng-container *ngIf="resident.StudyYear; else noValue">
                                        {{resident.StudyYear}}
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>

            <div class="row" *ngIf="canChangeSpeciality && residentInfo.length > 1">
                <div class="col-sm-6 form-field">
                    <label class="form-label">{{'courseEqualization_lblChangeSpeciality' | translate}}</label>
                    <app-select [(ngModel)]="model.SpecialityId"
                                [options]="residentInfo"
                                [valueProperty]="'SpecialityId'"
                                [displayFn]="specialityDisplayFn"
                                [required]="true"
                                [disabled]="model.Courses.length > 0"
                                (selectionChange)="onSpecialityChange()"
                                name="specialityId">
                    </app-select>
                </div>
            </div>

            <div class="form-field required" *ngIf="canEdit">
                <label class="form-label">{{'courseEqualization_lblSupervisor' | translate}}</label>
                <div class="row">
                    <div class="col-sm-8">
                        <app-autocomplete [(ngModel)]="supervisorUpdate"
                                          name="supervisorUpdate"
                                          limit="10"
                                          [required]="true"
                                          [options]="supervisorOptions"
                                          [displayFn]="supervisorDisplayFn"
                                          [placeholder]="'courseEqualization_supervisorFilterPlaceholder' | translate"
                                          (search)="filterSupervisors($event)">
                            <ng-template #optionTemplate let-option>
                                <div>{{option.FirstName}} {{option.LastName}}</div>
                            </ng-template>
                        </app-autocomplete>
                    </div>
                </div>
            </div>

            <app-alert *ngIf="model.ApprovalDecision" level="info">
                <label>{{'courseEqualization_lblApprovalDecision' | translate}}</label>
                <div>{{model.ApprovalDecision}}</div>
                <div class="text-sub" *ngIf="model.ApprovalComment">{{model.ApprovalComment}}</div>
            </app-alert>

            <ul ngbNav #nav="ngbNav" class="nav-tabs">
                <li [ngbNavItem]="'courses'">
                    <a ngbNavLink>
                        {{'courseEqualization_tabCourses' | translate}}
                        <ng-container *ngIf="selectedCourseCount"> ({{selectedCourseCount}})</ng-container>
                    </a>
                    <ng-template ngbNavContent>
                        <section class="block-em course-block" *ngFor="let inner of model.Courses">
                            <ng-container *ngIf="isPowerUser">
                                <span *ngIf="checkCourseValidity(inner); else courseStatusInvalid" class="course-status course-status-valid">
                                    <i class="fi fi-rs-check"></i>
                                </span>
                                <ng-template #courseStatusInvalid>
                                    <span class="course-status course-status-invalid" [ngbTooltip]="'courseEqualization_fillInnerCourseInfo' | translate">
                                        <i class="fi fi-rs-cross"></i>
                                    </span>
                                </ng-template>
                            </ng-container>

                            <div class="course-block-hero">
                                <button type="button" class="course-block-toggle" (click)="util.toggle(inner)">
                                    <i class="fi fi-rs-angle-up" *ngIf="util.isExpanded(inner); else courseCollapsedIcon"></i>
                                    <ng-template #courseCollapsedIcon>
                                        <i class="fi fi-rs-angle-right"></i>
                                    </ng-template>
                                </button>

                                <div class="course-block-hero-content">
                                    <header class="block-header">
                                        <h5 class="course-block-title">
                                            <span>{{inner.Code}} {{inner.Name}}</span>
                                            <span class="text-sub">{{'courseEqualization_courseToEqualize' | translate}}</span>
                                        </h5>

                                        <aside *ngIf="canEdit">
                                            <button type="button" (click)="editCourse(inner)" class="btn btn-outline-primary" *ngIf="isPowerUser">
                                                <i class="fi fi-rs-exchange"></i>
                                                {{'courseEqualization_btnEqualize' | translate}}
                                            </button>

                                            <button type="button" (click)="removeCourse(inner)" class="btn btn-outline btn-icon" [ngbTooltip]="'remove' | translate">
                                                <i class="fi fi-rs-trash"></i>
                                            </button>
                                        </aside>
                                    </header>

                                    <div class="course-block-stats">
                                        <div class="data-value">
                                            <label>{{'courseEqualization_lblCreditedGrade' | translate}}</label>
                                            <div>
                                                <ng-container *ngIf="inner.TheoryGradeValue || inner.IsEqualizedWithNoGrade; else noResidencyValue">
                                                    {{inner.IsEqualizedWithNoGrade ? ('courseEqualization_equalizedWithNoGrade' | translate) :  inner.TheoryGradeValue}}
                                                </ng-container>
                                                <span class="mute">&nbsp;({{'courseEqualization_theory' | translate}})</span>
                                            </div>
                                        </div>

                                        <div class="data-value">
                                            <label>{{'courseEqualization_lblCreditedGrade' | translate}}</label>
                                            <div>
                                                <ng-container *ngIf="inner.PracticeGradeValue || inner.IsEqualizedWithNoGrade; else noResidencyValue">
                                                    {{inner.IsEqualizedWithNoGrade ? ('courseEqualization_equalizedWithNoGrade' | translate) :  inner.PracticeGradeValue}}
                                                </ng-container>
                                                <span class="mute">&nbsp;({{'courseEqualization_practice' | translate}})</span>
                                            </div>
                                        </div>

                                        <div class="data-value">
                                            <label>{{'courseEqualization_lblCreditedEcts' | translate}}</label>
                                            <div>
                                                {{getCreditedEcts(inner) | number:'1.0-2':'en-US'}}
                                                <span class="mute">
                                                    {{'courseEqualization_outOf' | translate}}
                                                </span>
                                                {{(inner.Ects) | number:'1.0-2':'en-US'}}
                                            </div>
                                        </div>

                                        <div class="data-value">
                                            <label>{{'courseEqualization_lblCreditedWeeks' | translate}}</label>
                                            <div>
                                                {{getCreditedWeeks(inner)}}
                                                <span class="mute">
                                                    {{'courseEqualization_outOf' | translate}}
                                                </span>
                                                {{inner.Weeks}}
                                            </div>
                                        </div>

                                        <div class="data-value">
                                            <label>{{'courseEqualization_lblStudyYear' | translate}}</label>
                                            <div>{{inner.StudyYear}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-2" *ngIf="util.isExpanded(inner)">
                                <app-table [rows]="inner.Courses" [columns]="outerColumns" [showTotal]="false" [style]="'plain'" sticky="right">
                                    <ng-template #rowTemplate let-row>
                                        <tr>
                                            <td>
                                                <div class="text-top">{{row.Name}}</div>
                                                <div class="text-mute" *ngIf="row.University">{{row.University}}</div>
                                                <div class="text-mute" *ngIf="row.Programme">{{row.Programme}}</div>
                                            </td>
                                            <td>{{row.Weeks}}</td>
                                            <td>{{row.Ects | number:'1.0-2':'en-US'}}</td>
                                            <td>{{row.TheoryGradeValue}}</td>
                                            <td>{{row.PracticeGradeValue}}</td>
                                            <td>
                                                <div *ngFor="let a of row.Attachments" class="attachment-row" [title]="a.FileName">
                                                    <span *ngIf="row.Attachments.length > 1">&bull;&nbsp;</span>
                                                    <a *ngIf="a.Id" href="#" (click)="$event.preventDefault(); downloadAttachment(a)">
                                                        {{util.compactFileName(a.FileName, 20)}}
                                                    </a>
                                                    <ng-container *ngIf="!a.Id">{{util.compactFileName(a.FileName, 20)}}</ng-container>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-actions">
                                                    <button (click)="viewCourse(inner, row)" type="button" class="btn btn-outline btn-icon" *ngIf="!canEdit && !canOnlyAppendFiles"
                                                            [ngbTooltip]="'view' | translate">
                                                        <i class="fi fi-rs-angle-right"></i>
                                                    </button>

                                                    <button (click)="editCourse(inner, row)" type="button" class="btn btn-outline btn-icon" *ngIf="canEdit || canOnlyAppendFiles"
                                                            [ngbTooltip]="'edit' | translate">
                                                        <i class="fi fi-rs-pencil"></i>
                                                    </button>

                                                    <button (click)="removeCourse(inner, row)" type="button" class="btn btn-outline btn-icon" *ngIf="canEdit"
                                                            [ngbTooltip]="'remove' | translate">
                                                        <i class="fi fi-rs-trash"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </app-table>

                                <div class="mt-1 mb-2" *ngIf="canEdit">
                                    <button class="btn btn-tertiary" type="button" (click)="addCourse(inner)"
                                            [ngbTooltip]="'courseEqualization_hintAddInnerCourse' | translate">
                                        <i class="fi fi-rs-plus"></i>
                                        {{'courseEqualization_btnAddInnerCourse' | translate}}
                                    </button>
                                </div>
                            </div>
                        </section>

                        <div class="mt-4" *ngIf="canEdit">
                            <button class="btn btn-outline-primary" type="button" (click)="addCourse()"
                                    [ngbTooltip]="'courseEqualization_hintAddOuterCourse' | translate">
                                <i class="fi fi-rs-plus"></i>
                                {{'courseEqualization_btnAddOuterCourse' | translate}}
                            </button>
                        </div>
                    </ng-template>
                </li>

                <!--seminar functionality not available yet-->
                <!--<li [ngbNavItem]="'seminars'">
            <a ngbNavLink>
                {{'courseEqualization_tabSeminars' | translate}}
                <ng-container *ngIf="selectedSeminarCount"> ({{selectedSeminarCount}})</ng-container>
            </a>
            <ng-template ngbNavContent>
                <div class="mt-3">
                    <app-table [rows]="seminars" [columns]="seminarColumns" pageSize="100">
                        <ng-template #rowTemplate let-row>
                            <tr>
                                <td>
                                    <app-checkbox name="seminarEqualize_{{row.Id}}" [(ngModel)]="row.selected" [disabled]="!canEdit"></app-checkbox>
                                </td>
                                <td>{{row.Theme}}</td>
                                <td>{{row.Instructor}}</td>
                                <td>{{row.Location}}</td>
                            </tr>
                        </ng-template>
                    </app-table>
                </div>
            </ng-template>
        </li>-->
            </ul>
            <div [ngbNavOutlet]="nav"></div>

            <!--currently not available-->
            <!--<div class="form-field">
        <label class="form-label">{{'courseEqualization_attachments' | translate}}</label>
        <div *ngFor="let a of model.Attachments; let i = index" class="d-flex mb-2">
            <div class="flex-grow-1">
                <app-file [(ngModel)]="a.File"
                          [accept]="attachmentExtensions"
                          [maxSize]="attachmentMaxSize"
                          name="attachment{{i}}"
                          [immediate]="!a.Id && !a.File && !a.FileName"
                          [disabled]="!canEdit"
                          (fileChange)="onFileChange($event, a)"
                          #attachmentInput="ngModel"></app-file>
                <div class="invalid-feedback" *ngIf="attachmentInput.errors?.maxSize">{{attachmentInput.errors?.maxSize}}</div>
                <div class="invalid-feedback" *ngIf="checkDuplicateFileName(a)">{{'courseEqualization_duplicateFileName' | translate}}</div>
            </div>

            <button class="btn btn-outline btn-icon align-self-end ms-3" *ngIf="a.Id"
                    (click)="downloadAttachment(a)" [ngbTooltip]="'download' | translate">
                <i class="fi fi-rs-download"></i>
            </button>
        </div>

        <div *ngIf="canEdit">
            <button class="btn btn-outline" type="button" (click)="addAttachment()">
                <i class="fi fi-rs-plus"></i>
                {{'onCallShift_btnAddFile' | translate}}
            </button>
        </div>
    </div>-->

            <div class="data-value mt-3" *ngIf="!isPowerUser">
                <label>{{'courseEqualization_lblEnrollYear' | translate}}</label>
                <div>
                    <ng-container *ngIf="model.EnrollYear; else noResidencyValue">
                        {{model.EnrollYear}}
                    </ng-container>
                </div>
            </div>

            <div class="row mt-3" *ngIf="isPowerUser">
                <div class="form-field col-sm-6">
                    <label class="form-label">{{'courseEqualization_lblEnrollYear' | translate}}</label>
                    <app-select [(ngModel)]="model.EnrollYear"
                                [options]="enrollYearOptions"
                                name="enrollYear">
                    </app-select>
                </div>
            </div>

            <div class="mt-3" *ngIf="canEdit && totalAttachments > attachmentLimit">
                <app-alert level="danger">
                    {{'courseEqualization_maxFileCountExceeded' | translate | formatString:attachmentLimit}}
                </app-alert>
            </div>

            <div class="mt-3" *ngIf="canApprove && hasIncompleteCourse">
                <app-alert level="warning">
                    {{'courseEqualization_fillInnerCourseInfo' | translate}}
                </app-alert>
            </div>
        </ng-container>

        <div class="form-actions">
            <span class="form-actions-group">
                <button class="btn btn-outline-primary" type="button" (click)="submit()" [disabled]="!resident" *ngIf="canSubmit">
                    <i class="fi fi-rs-paper-plane"></i>
                    {{'courseEqualization_btnSubmit' | translate}}
                </button>

                <button class="btn btn-secondary" type="button" (click)="returnForAddition()" *ngIf="canReturnForAddition">
                    <i class="fi fi-rs-arrow-left"></i>
                    {{'courseEqualization_btnReturnForAddition' | translate}}
                </button>

                <button class="btn btn-secondary" type="button" (click)="returnForApproval()" *ngIf="canReturnForApproval">
                    <i class="fi fi-rs-arrow-left"></i>
                    {{'courseEqualization_btnReturnForApproval' | translate}}
                </button>

                <button class="btn btn-outline-primary" type="button" (click)="approve()" *ngIf="canApprove"
                        [disabled]="hasIncompleteCourse">
                    <i class="fi fi-rs-list-check"></i>
                    {{'courseEqualization_btnApprove' | translate}}
                </button>

                <button class="btn btn-outline-primary" type="button" (click)="createProject()" *ngIf="canCreateProject">
                    <i class="fi fi-rs-shield-check"></i>
                    {{'courseEqualization_btnProject' | translate}}
                </button>
            </span>

            <span class="form-actions-group">
                <button class="btn btn-outline" type="button" [routerLink]="['/course-equalizations'] | localize">
                    {{'courseEqualization_btnClose' | translate}}
                </button>

                <button class="btn btn-primary" type="button" (click)="save()" [disabled]="!resident" *ngIf="canEdit">
                    {{'courseEqualization_btnSave' | translate}}
                </button>
            </span>
        </div>
    </form>
</div>

<ng-template #noValue>{{'courseEqualization_undefined' | translate}}</ng-template>
<ng-template #noResidencyValue>
    <ng-container *ngIf="!isPowerUser else noValue">
        {{'courseEqualization_undefinedResidencyValue' | translate}}
    </ng-container>
</ng-template>
